import {Hydra} from '../generic/hydra';

import {UtilisateurInterface} from './Utilisateur';
import {LaboratoireReferenceInterface} from './LaboratoireReference';
import {
    LaboratoireReferenceSuggestion as LaboratoireReferenceSuggestionBaseInterface
} from '../../interface/api/LaboratoireReferenceSuggestion';

export type LaboratoireReferenceSuggestionInterface = LaboratoireReferenceSuggestionBaseInterface;

export class LaboratoireReferenceSuggestion extends Hydra implements LaboratoireReferenceSuggestionInterface {

    id?: number | null;

    commentaire?: string | null;

    dateCreation?: string | Date | null;

    createur?: UtilisateurInterface | string | null;

    /* 0 = non traité, 1 =
     */
    etat?: number | null;

    /* Objet de type LaboratoireReference, cf API dédiée
     */
    laboratoireReference?: LaboratoireReferenceInterface | string | null;


    constructor(options: LaboratoireReferenceSuggestionInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
